import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useLanguage } from '@ipc/ipc-core';
import { useHistory, useLocation } from 'react-router-dom';
import ListTableContainer from '../../../common/list-table/containers/ListTableContainer';

function MrdMonitoringReportPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={5}>{children}</Box>}
    </Typography>
  );
}

MrdMonitoringReportPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SimpleTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState('/');
  const [, language] = useLanguage();
  const history = useHistory();
  const location = useLocation();

  const { withURL } = props;

  const updateValue = (newValue) => {
    const { pathname } = location;
    if (!pathname.endsWith(newValue)) {
      history.push(language(`/monitoring${newValue}`));
    }
    setValue(newValue);
  };

  const handleChange = (event, newValue) => {
    updateValue(newValue);
  };

  useEffect(() => {
    if (withURL && withURL !== value) {
      updateValue(withURL);
    }
  }, [withURL]);

  return (
    <div className={classes.root}>
      <AppBar position="static" color="primary">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" centered>
          <Tab label="" value="/" className="hidden-tab" />
          <Tab label="All MRDs" {...a11yProps(0)} value="/all-mrds" />
          <Tab label="All Issues" {...a11yProps(1)} value="/all-issues" />
          <Tab label="Reported by user" {...a11yProps(2)} value="/user-reported" />
          <Tab label="XML delayed" {...a11yProps(3)} value="/xml-delayed" />
          <Tab label="No sync" {...a11yProps(4)} value="/no-sync" />
        </Tabs>
      </AppBar>
      <MrdMonitoringReportPanel value={value} index="/all-mrds">
        <ListTableContainer tableId="MRD_MONITORING_REPORT_ALL_MRDS" />
      </MrdMonitoringReportPanel>
      <MrdMonitoringReportPanel value={value} index="/all-issues">
        <ListTableContainer tableId="MRD_MONITORING_REPORT_ALL_ISSUES" />
      </MrdMonitoringReportPanel>
      <MrdMonitoringReportPanel value={value} index="/user-reported">
        <ListTableContainer tableId="MRD_MONITORING_REPORT_REPORTED_BY_USER" />
      </MrdMonitoringReportPanel>
      <MrdMonitoringReportPanel value={value} index="/xml-delayed">
        <ListTableContainer tableId="MRD_MONITORING_REPORT_XML_DELAYED" />
      </MrdMonitoringReportPanel>
      <MrdMonitoringReportPanel value={value} index="/no-sync">
        <ListTableContainer tableId="MRD_MONITORING_REPORT_NO_SYNC" />
      </MrdMonitoringReportPanel>
    </div>
  );
}

SimpleTabs.propTypes = {
  withURL: PropTypes.string,
};
